export default {
"type": "FeatureCollection",
"name": "refugis",
"crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
"features": [
{ "type": "Feature", "properties": { "id": 1, "Nom": "Refugi de Santa Cecília", "Observ": "Refugi de la FEEC - Tancat" }, "geometry": { "type": "Point", "coordinates": [ 1.817831877887301, 41.611000679514667 ] } },
{ "type": "Feature", "properties": { "id": 2, "Nom": "Refugi de Vicenç Barber", "Observ": "Refugi de la FEEC - Guarda: Llorenç Barba - Tel. 628787390 | e-correu: agulles.refugi@feec.cat" }, "geometry": { "type": "Point", "coordinates": [ 1.784818831657243, 41.606326949786286 ] } },
{ "type": "Feature", "properties": { "id": 3, "Nom": "Refugi de Sant Benet", "Observ": "Guarda: Efren - Tel. 622 879 393" }, "geometry": { "type": "Point", "coordinates": [ 1.831043913652923, 41.593400925849579 ] } }
]
}
